import { BaseApiSelector } from "@bornfight/aardvark";
import { ResourceType } from "enums/ResourceType";
import { QuestionnaireJSONAModel } from "interfaces/jsona-models/QuestionnaireJSONAModel";

export class QuestionnaireSelector extends BaseApiSelector<QuestionnaireJSONAModel> {
  constructor() {
    super(ResourceType.Questionnaire);
  }
}
